import cachios from 'cachios';
import Client from './client';

const cachiosInstance = cachios.create(Client);

export default cachiosInstance;
